var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-input-playground"},[_c('text-input',{attrs:{"autofocus":false,"labelText":'הכנס רק מספרים',"value":_vm.numValue,"onInput":_vm.setNumValue,"error":_vm.error,"topLeftLabel":_vm.errorLabel}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e546073","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/base-ui-playground/components/TextInputPlayground.vue
// module id = null
// module chunks = 